<h5>{{site?.name}}</h5>
<mat-tab-group mat-align-tabs="center" (selectedTabChange)="changed($event)">
  <mat-tab [label]="FINANCIAL_NAME">
    @if (site) {
      <app-site-financial [site]="site" [(financialDirty)]="financialDirty"></app-site-financial>
    }
  </mat-tab>
  <mat-tab [label]="DEVICES_NAME">
    @if (site) {
      <app-site-devices [site]="site" [(devicesDirty)]="devicesDirty"></app-site-devices>
    }
  </mat-tab>
  @if (hasOperationsPermission) {
    <mat-tab [label]="OPERATIONS_NAME">
      @if (site) {
        <app-site-operations [site]="site"></app-site-operations>
      }
    </mat-tab>
  }
</mat-tab-group>
